import withField, { Props } from '../withField';
import { Checklist as Element } from 'components/elements';

const Checklist: React.FC<Props> = withField(Element);
Checklist.displayName = 'ChecklistField';

export default Checklist;
